// extracted by mini-css-extract-plugin
export default {"container":"IntentSurvey_container__5yJxk","tada":"IntentSurvey_tada__eAS8R","heading":"IntentSurvey_heading__sWWaX"};